<template>
  <div v-if="loading">
    <oil-cap
        title="ДОВЕРЕННОСТИ"
        :buttons="[
        {
          route: 'coming-empowerment',
          name: 'Добавить Доверенность'
        }
      ]"
        :items="empowerments"
    />
    <v-divider class="my-2"/>

    <oil-table
        :keys="[
        {
          text: 'Поставщик',
          value: 'SupplierName'
        },
        {
          text: 'ФИО',
          value: 'ContactPerson'
        },
        {
          text: 'Номер',
          value: 'Number'
        },
        {
          text: 'Количество',
          value: 'Amount'
        },
        {
          text: 'Статус',
          value: 'Status'
        }
      ]"
        :items="empowerments"
        :paginate='count'
        @paginateAction='paginate'
        :rowClick="handleRowClick"
    >
    </oil-table>
  </div>
</template>

<script>

import {coreApi} from "~/services/core";

export default {
  components: {
    OilTable: () => import('@/components/helper/oil.table.vue'),
    OilCap: () => import('@/components/helper/oil.cap'),
    OilModal: () => import('@/components/helper/form/oil.delete.modal'),
  },
  data: () => ({
    loading: false,
    empowerments: [],
    status: {
      active: 'Активный',
      notsigned: 'Неподписанный',
      special: 'Особый',
      inactive: 'Неактивный'
    },
    count:{
      count:0
    }

  }),
  async created() {
    await this.paginate((this.currentPage - 1) * 10)

    // const empowerments = await coreApi.get(`coming-empowerment`)
    // this.empowerments = empowerments.data?.map(empowerment => {
    //   return {
    //     Id: empowerment.Id,
    //     SupplierName: empowerment.Supplier.Name,
    //     ContactPerson: empowerment.Supplier.ContactPerson,
    //     Number: empowerment.Number,
    //     Amount: empowerment.LimitInTonnes,
    //     Status: this.status[empowerment.Status],
    //   }
    // })
    this.loading = true
  },
  methods: {
    handleRowClick({Id}) {
      this.$router.push(`coming-empowerment/${Id}`)
    },
    async paginate(page) {
      const empowerments = await coreApi.get(`coming-empowerment/${page}`)
      const { count, dates } = empowerments.data
      this.count.count = count
      this.empowerments = dates?.map(empowerment => {
        return {
          Id: empowerment.Id,
          SupplierName: empowerment.Supplier.Name,
          ContactPerson: empowerment.Supplier.ContactPerson,
          Number: empowerment.Number,
          Amount: empowerment.LimitInTonnes,
          Status: this.status[empowerment.Status],
        }
      })
    },
  }
}
</script>